<template>
  <div class="container-base" v-once>
    <div class="pages page-static">
      <div class="page-static-inner">
        <h1 style="font-size: 140%;">【개인정보처리방침(Privacy Policy)】</h1>
        <p>주식회사Yagish(이하 「당사」라　함)는 개인정보보호에 관한 개인정보보호법(이하 「법」이라 함) <br>
          기타 관련 법령을 준수함과 동시에 다음과 같이 개인정보처리방침(이하「본 정책」이라 함)을 도입하여, 본 정책에 적정한 개인정보를 수집합니다. 또한 본 정책에서 사용하는 용어 등의 의미는 본 정책에서 별도로 정하지 않는 한 법령에 준거합니다. 또한 본 정책에 동의한 경우 2023년 6월 1일 이전에 당사가 운영하는 「yagish」 또는「야기오퍼」서비스를 통해 취득한 개인정보도 본 정책에 근거하여 수집합니다.<br>
2-3-12 Ebisu Nishi, Shibuya-ku, Tokyo, Japan<br>
주식회사 Yagish<br>
대표이사 김상집<br>

        </p>
        <h2>1. 개인정보의 이용목적</h2>
        <p>당사는, 「yagish」, 「야기오퍼」 그 외 인재관련 서비스 등의 당사가 제공하는 서비스(이하 「당사 서비스」라고 함)에 의해 수집한 개인정보를　이하의 목적으로 이용합니다. 또한 당사 서비스의 이용약관, 이용자 통지 등에 있어서, 다음 각 호와 다른 이용목적을 명시한 경우, 이하의 이용목적에 추가로 해당 이용목적을 취급합니다.<br>
【서비스 이용자의 개인정보】<br>
당사는 당사 서비스에서 수집한 개인정보를 다음의 목적으로 이용합니다.<br>
1.당사 서비스 제공 및 운영<br>
2.당사 서비스에 의해 취업이 결정된 구직자의 정착 및 활약 상황의 앙케이트 조사 등의 분석 <br>
3.당사 서비스에 관한 문의 등에 대한 답변<br>
4.당사, 당사의 그룹회사 및 제휴기업의 서비스에 관한 안내나 광고의 전달을 위해 이용자가 관련 서비스에 이용등록 시 등록정보 공유<br>
5.구직, 이직활동에 필요한 정보 (당사, 당사 그룹회사 또는 제휴기업이 개최하는 세미나, 이벤트 등의 안내를 포함)등의 제공<br>
6.당사 프로모션 활동의 협력에 관한 연락(인터뷰 및 앙케이트, 당사가 개최하는 세미나, 이벤트를 통해서 취득한 정보를 집계, 공표하는 것을 포함)<br>
7.당사 서비스의 기획, 개발, 품질 향상, 개선<br>
8.당사 서비스에 포함되는 각종 서비스(향후 추가되는 것을 포함)의 상호 연계<br>
9.당사 서비스의 등록정보, 구직자의 오퍼 수신이력이나 오퍼 승인이력, 본 사이트의 열람 및 투고이력 등의 정보를 분석해 당사 서비스 이용기업의 구직자 검색 결과의 표시 순위 최적화에 이용 <br>
10.당사 서비스를 이용한 구직자 및 학생의 개인정보 및 당사 서비스의 활동정보에 대해 개인 식별을 할 수 없는 형태로 통계정보를 작성하여 기업이나 대학, 관계기관 등의 제3자에게 제공<br>
11.당사 서비스의 이용약관 그 외의 정책 개정, 이용방법의 변경의 안내<br>
12.구인 구직 정보의 적절한 매칭 제공<br>
13.구직자의 승인에 따른 「야기오퍼」 이용기업에 개인정보 공개<br>
14.당사 서비스 약관 등에서 별도로 정한 개인정보이용목적<br>
15.그 외 전 각호에 준하는 목적을 위해 이용<br>
【기업 담당자의 개인정보】<br>
당사는 당사 서비스에 등록된 정보를 다음의 목적으로 이용합니다.<br>
1.당사 서비스 제공 및 운영<br>
2.당사 서비스에 관한 문의 등에 대한 답변<br>
3.당사 서비스, 당사 그룹회사 및 제휴기업의 서비스에 관한 안내나 광고의 전달<br>
4. 당사 프로모션 활동의 협력에 관한 연락(인터뷰 및 앙케이트, 당사가 개최하는 세미나, 이벤트를 통해서 취득한 정보를 집계해　공표하는 것을 포함)<br>
5.당사, 당사의 그룹회사 및 제휴기업(공동주체기업을 포함)이 개최하는 세미나, 이벤트 등의 안내나 신청의 접수, 앙케이트 실시, 분석 등이나 세미나, 이벤트 등에 참가한 구직자, 학생 및 당사 서비스 이용기업 담당자에게 세미나, 이벤트 후의 팔로우업이나 필요 정보의 제공<br>
6.당사 서비스의 기획, 개발, 품질 향상, 개선<br>
7.기업 담당자의 오퍼 송신이력이나 본 사이트의 열람 및 투고이력 등의 정보를 분석하고, 당사 서비스 이용기업의 구직자 검색 결과의 표시 순위의 최적화에 이용<br>
8.당사 서비스의 이용약관의 개정, 이용방법의 변경 안내<br>
9.개인정보의 취득 시 이용자에게 개별 통지의 목적<br>
10. 그 외 전 각호에 준하는 목적을 위해 이용<br>
【채용후보자의 개인정보】<br>
당사는 당사의 등록정보를 다음의 목적으로 이용합니다.<br>
1.당사를 통한 채용활동의 실시<br>
2.당사를 통한 채용활동 관련된  연락<br>
3.당사의 고용기회와 이벤트 등에 대한 정보의 제공<br>
4.당사의 채용전형이나 입사 후 소속 배치 등에 있어서 후보자의 적격성 평가<br>
5.장래의 채용계획을 위한 통계자료 이용 등 채용활동에 부수하는 목적<br>
6.채용 후보자의 정보를 관리<br>
7.그 외 전 각호에 준하는 목적을 위해 이용<br>
</p>
        <h2>2. 개인데이터의 제3자 제공</h2>
        <p>1.당사는 법령으로 정하는 경우를 제외하고, 사전에 이용자의 사전동의 없이 개인정보를 동 범위를 초과하여 제3자에 제공하지 않습니다.<br>
2.전항에 관계없이 당사는 이용자의 개인정보를 다음과 같이 제3자에게 제공할 수 있습니다.<br>
① 당사 서비스의 제공 및 채용활동의 분석을 위해 이름, 주소, 전화번호, 이메일 등의 당사 서비스를 통해 취득한 구직자의 개인정보를 당사 서비스 이용기업에 전자기록 등에 의한 방법으로 제공하는 경우<br>
② 세미나 등의 이벤트 실시, 서비스 제공, 향후 유익한 서비스나 이벤트, 세미나의 안내 및 앙케이트 내용 분석 등을 위해 아래에 정하는 구직자, 학생 및 기업 담당자의 정보를 제휴기업에 서면(전자기록을 포함한다. 이하 동일)등에 의한 방법으로 제공하는 경우<br>
③ 흥미, 관심 등을 분석하고 그 결과에 따라 당사의 광고를 전달하고 광고 결과를 측정하기 위해 이름, 이메일, 쿠키 ID, 광고식별자 등의 온라인식별자, 회원 ID 및 기타 고유식별자, 사이트의 열람이력, 검색 이력, 상품 구매이력, 서비스의 이용이력, 광고 등의 반응, 그 외의 행동이력 등의 당사 서비스를 통해서 취득한 구직자 및 학생의 개인정보를, 당사 제휴기업인 광고전달사업자, SNS 등의 플랫폼운영사업자, 제휴사업자 및 미디어사업자 등에게 전자기록의 제공 등에 의한 방법으로 제공하는 경우<br>
④기타 개별서비스의 이용약관 등에서 서비스 이용자의 합의하에 정한 경우<br>
【구직자 및 학생의 개인정보】<br>
이름, 주소, 전화번호, 이메일 주소 등 당사 서비스를 통해 수집한 구직자의 개인정보<br>
【기업 담당자의 개인정보】<br>
소속기업, 소속부서, 직위, 이름, 전화번호, 이메일, 각종 이벤트 및 세미나 등에의 참가 상황, 앙케이트  설문결과 등의 당사 서비스를 통해 취득한 기업 담당자의 개인정보<br>
</p>
        <h2>3. 위탁</h2>
        <p>당사는 이용목적의 달성에 필요한 범위 내에서 개인정보의 취급의 전부 또는 일부를 위탁하는 경우가 있습니다. 또한 개인정보의 취급을 위탁하는 경우에는 적절한 위탁 받은 업체(해외사업자 포함)를 선정하여 개인정보가 안전하게 관리되도록 최선을 다하고 있습니다. 당사가 강구하고 있는 안전관리 조치의 내용에 대해서는, 아래와 같은 「개인정보관리사무국 」에 기재된 연락처로 연락바랍니다.<br>
</p>
        <h2>4. 개인데이터의 공유</h2>
        <p>당사는 다음과 같이 기업 담당자의 개인데이터를 공유합니다.<br>
1.공유되는 개인정보 항목<br>
기업 담당자의 소속조직명, 직위, 부서, 이름, 연락처(전화 번호, 이메일 등) 및 이들에 부수되는 정보<br>
2.공유 범위<br>
당사 및 당사 그룹회사(※아래 URL을 참조하십시오.)<br>
https://www.yagish.jp/company/<br>
3.이용목적<br>
당사 및 당사 그룹회사의 서비스나 당사 및 당사 그룹회사가 개최하는 세미나, 이벤트 등에 관련된 각종 안내나 광고의 제공<br>
4.공유하는 개인정보의 관리 책임자<br>
주식회사 Yagish 대표이사 김상집 <br>
</p>
        <h2>5.취득 방법</h2>
        <p>기업 담당자로부터 서면으로 취득하는 방법
</p>
        <h2>6. 당사가 취급하는 개인 데이터 관리</h2>
        <p>당사의 개인 데이터 관리 시스템<br>
 개인정보취급사업자(당사)의 명칭, 주소 및 대표자명(상기와 동일)<br>
개인정보보호관리자의 직책 및 연락처(하기 8참조)<br>
➂ 보유 개인데이터 이용목적(상기1과 동일)<br>
➃ 공개 등의 요청 절차<br>
공개 등의 요청에 대해서는, 하기의 당사 개인정보관리사무국로 연락해 주시기 바랍니다. (하기 8 참조). 또한 당사 서비스 등록내용은 당사 서비스상에서 열람, 수정의 신청이 가능하므로 이용하시기 바랍니다. <br>
2.당사가 시행하는 안전관리조치<br>
당사는 수집한 개인데이터에 대하여 적절하고 엄중하게 관리하고, 개인데이터의 유출, 소멸, 훼손 등의 방지에 적절한 대책을 강구하며 당사 직원에게 필요, 적절한 감독을 실시하고, 또한 당사가 개인데이터의 취급을 위탁하는 경우에는 위탁 받은 업체가 개인데이터의 안전 관리를 도모할 수 있도록 필요, 적절한 감독을 실시하여 이용자의 개인데이터를 보호하기 위해 최선을 다하고 있습니다. 당사의 안전관리 조치는 다음과 같습니다.<br>
① 기본방침의 책정<br>
개인정보의 적정한 취급을 확보하고, 이용자의 고충처리를 위하여 개인정보 보호 방침을 책정<br>
② 개인데이터 취급에 관한 규율의 정비<br>
취득, 이용, 보존, 제공, 삭제 및 파기 등의 단계마다 취급방법, 책임자/담당자 및 그 임무 등에 대하여 개인정보 보호규정을 책정, 권한을 갖지 않는 자에 의한 개인데이터의 열람 방지의 조치 수행<br>
</p>
        <h2>7. 개인정보 제공의 임의성</h2>
        <p>당사에서 이용자에게 개인정보의 제공을 위탁하는 경우가 있습니다만, 제공자의 임의에 의한 것입니다. 개인정보를 제공할 수 없는 경우에는 해당 이용자에게 당사 서비스 제공이 제한될 수 있습니다.
</p>
        <h2>8. 공개대상 개인정보의 공개 등</h2>
        <p>1.요청 가능한 내용<br>
당사에서는 개인정보의 보호에 관한 법률(이하 「법」이라 함)에 근거해 해당이용자 본인이 식별되는 보유 개인정보에 관하여 보유한 자신의 개인정보 또는 그 대리인으로부터 다음의 요청을 수락합니다.
a. 「이용목적 통지」 요청<br>
b. 「공개」(제3자 제공기록 포함. 이하 동일) 요청<br>
c. 「내용 수정 또는 추가」 요청<br>
d. 「이용 중지, 삭제 및 제3자에게 제공 중지」 요청<br>
2.관리사무국 연락 방법<br>
당사의 개인정보 취급에 관한 문의, 공개 등의 요청에 대해서는 하기로 신청하시기 바랍니다.<br>
<서면에 의한 경우><br>
주식회사 Yagish 개인정보관리사무국<br>
2-3-12 Ebisu Nishi, Shibuya-ku, Tokyo, Japan<br>
<이메일에 의한 경우><br>
주식회사 Yagish 개인정보 관리사무국<br>
 support@yagish.jp<br>
3.수수료 및 그 징수방법 공개, 이용목적의 통지요청은 1건당 1,000엔(환불 발행요금 등은 고객 본인 부담)입니다. 이 수수료에는 당사에서 이용자에 우송 시 간이등기요금이 포함됩니다. 그 외, 실비가 발생 하는 경우에는 별도 요금이 요청됩니다. 내용의 정정, 추가, 삭제 및 이용정지의 경우는 수수료는 요청되지 않습니다. 수수료의 요청 방법은 정액소환 입니다.
</p>
      <h2>9. 쿠키 등의 수집, 이용 등</h2>
      <p>이 서비스에는 "쿠키(Cookie)"라는 기술을 사용하는 페이지가 있습니다. 웹페이지에 회원의 이메일을 표시하거나 회원전용 서비스의 이용상황 및 액세스상황을 계측하고 기록, 분석하기 위해 쿠키를 이용하는<br>
      경우가 있습니다. 이 경우 당사는 상기 측정, 기록, 분석 이외의 목적으로 이용하지 않습니다.<br>
      본 웹사이트상 또는 본 웹사이트를 통해 제3자가 제공하는 서비스(게재 광고 등의 제휴 프로그램이나 액세스 해석 등)에 액세스한 경우 해당 제3자가 제시하는 개인정보보호정책에 근거하여 쿠키나 웹비콘 등에<br>
      의해 정보수집의 목적으로 이용자의 IP주소, 방문일시, 유저 에이전트, 열람경로 등의 정보가 자동으로 취득, 제공되는 경우가 있습니다.<br>
      서비스 이용자가 본 웹사이트 및 본 웹사이트를 통해 액세스 한 제3자가 제공하는 서비스에 쿠키에 의해 취득된 정보를 제공하고 싶지 않은 경우, 서비스 이용자는 쿠키의 무효화를 통해 정보 제공을 거부할 수<br>
      있습니다.
      </p>
        <h2>10. 개인정보보호정책 변경 및 공지</h2>
        <p>당사에서는 법령의 변경, 운영방침의 변경 등에 따라 본 정책의 내용을 변경할 수 있습니다. 변경이 중요한 경우에는 사전에 변경내용을 이용자에게 고지합니다. 해당공지는 당사 사이트에 게시, 이용자에게 메일 통지 등의 방법 중에서 당사가 적절하다고 판단되는 방법으로 수행합니다. 본 정책의 변경은 당사가 정한 날에 모든 이용자의 관계에서 효력을 발생합니다. 다만, 변경에 대해서 고객의 동의가 필요한 경우에는 동의한 이용자와의 관계에서만 변경의 효력이 발생합니다.
</p> 
        <h2>11. 기타</h2>
        <p>당사 직원, 임원을 본인으로 하는 개인정보보호에 관한 사항 등에 대해서는 별도, 공표 또는 통지합니다.<br>
제정일: 2023년 6월 1일<br>
개정일: 2023년 9월 4일</p>
        <div>
        </div>
      </div>
    </div>
    </div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<script>
export default {
  data: function () {
    return {}
  },
  computed: {},
  methods: {},
  watch: {},
  mounted: function () { }
}
</script>
